import React from "react";
import { Link } from "react-router-dom";

//import Login from "./Login";
//import Logout from "./Logout";
import "./CSS/navigation.css";
import { auth } from "./firebase";
import "bootstrap/dist/css/bootstrap.css";
import Logout from "./Logout";
//import { FirebaseAuth, useForAuthorisation } from "./context";

// it takes in multiple props which are destructured - it comes from the various components - to set the navbar name colors

// all these props can be removed. in the other components use effect is already setting the nav name to the color when the
// component renders/paints...these clicks may not render?

//let initialrender = true;
function Navigation({
  savedIcon,

  stylingOnClickContact,
  stylingOnClickPricing,
  stylingOnClickFeatures,
  navColor1,
  navColor2,
  navColor3,
  navColor5,
  navColor6,
  navColor7,
  navColor8,
  navColor9,
  navColor10,
}) {
  // const [newData, setNewData] = useState([]);
  // const [activeState, setActiveState] = useState();
  // const [stylingOnClickTB, setStylingOnClickTB] = useState();

  // const [loading, setLoading] = useState(false);
  //const { emailDetails } = useForAuthorisation();
  //check if there exists a company , if not nav links should not be enabled.
  // let MainUserUID = auth.currentUser.uid;
  //const [linksdisabledboolean, setlinksdisabledboolean] = useState([]);
  // useEffect(() => {
  //   if (initialrender) {
  //     initialrender = false;
  //     return;
  //   }
  //   const urlDb = "/UserSelections/" + MainUserUID;
  //   const newUrlDb = database.ref(urlDb);

  //   newUrlDb.on("value", (snapshot) => {    setLoading(true);
  //     const accounts = snapshot.val();

  //     let newAccounts = [];

  //     newAccounts.push({ ...accounts });

  //     setNewData(newAccounts);

  //    setLoading(false); });

  //   return () => newUrlDb.off();
  // }, [MainUserUID]);
  //console.log(newData);
  // const [linksdisabled, setLinksDisabled] = useState(false);
  //is user hasnt added a company all links should redirect to info page, or alternatively we can set up a demo company but
  //its not setup yet. if users go to links it should work, however errors may result due to less optimizations for no company
  //added
  //
  // const linksdisabledboolean =
  //   newData.map((el1) => Object.keys(el1).length).toString() == 0
  //     ? true
  //     : false;
  //use useEffect?

  // useEffect(() => {
  //   if (initialrender) {
  //     initialrender = false;
  //     return;
  //   }
  //   setLoading(true);

  //   setlinksdisabledboolean(
  //     newData.map((el1) => Object.keys(el1).length).toString() == 0
  //       ? true
  //       : false
  //   );
  //   setLoading(false);
  // }, [newData]);

  // console.log(linksdisabledboolean);
  // if (loading) {
  //   return (
  //     <div
  //       // style={{ marginRight: 115, marginTop: 10 }}
  //       className="spinner-border text-primary"
  //       role="status"
  //     ></div>
  //   );
  // }

  let uid = auth.currentUser ? auth.currentUser.uid : null;

  // function InfoNavigation(infopage) {
  //   return (
  //     <nav
  //       className="navbar navbar-expand-lg navbar-light bg-light"
  //       style={{
  //         backgroundImage: "linear-gradient(45deg, #e7fcff, transparent)",
  //       }}
  //     >
  //       <Link className="nav-link" to="/AddBusiness">
  //         | Add Entity
  //       </Link>
  //       <Link className="nav-link" to="/Payment">
  //         | Payments
  //       </Link>
  //       {/* {memberBoolean && (
  //         <Link className="nav-link" to="signUpAndAddUser">
  //           | Add User
  //         </Link>
  //       )} */}

  //       <Link className="nav-link" to="/UserProfile">
  //         |{" "}
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           width="16"
  //           height="16"
  //           fill="currentColor"
  //           className="bi bi-gear"
  //           viewBox="0 0 16 16"
  //         >
  //           <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
  //           <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
  //         </svg>{" "}
  //         User Profile
  //       </Link>

  //       {/* <Link className="nav-link" to="/GiveUserAccess">
  //       Give user access
  //     </Link> */}

  //       <Link className="nav-link" to="/settings">
  //         | Settings
  //       </Link>
  //       {/* <Link className="nav-link" to="/Support">
  //         | Support
  //       </Link> */}
  //       <Link className="nav-link" to="/ShortCut">
  //         | Dashboard
  //       </Link>

  //       {/* {infopage ? (
  //         <input
  //           style={{ width: 200 }}
  //           value={searchValue}
  //           className="searchinput"
  //           placeholder="Search"
  //           type="search"
  //           id="TableSearch"
  //           name="search"
  //           aria-label="Search through table content"
  //           onChange={handleSearchValue}
  //         ></input>
  //       ) : null}
  //       infopage ? (
  //       //   <span style={{ display: "flex", alignItems: "center", gap: 12 }}>
  //       //     <input
  //       //       style={{ width: 200 }}
  //       //       value={searchValue}
  //       //       className="searchinput"
  //       //       placeholder="Search"
  //       //       type="search"
  //       //       id="TableSearch"
  //       //       name="search"
  //       //       aria-label="Search through table content"
  //       //       onChange={handleSearchValue}
  //       //     />
  //           {/* <div
  //             className="custom-control custom-switch"
  //             style={{ marginLeft: "20px" }}
  //           >
  //             <input
  //               className="custom-control-input"
  //               type="checkbox"
  //               checked={showConciseView}
  //               onChange={handleConsiceViewChange}
  //               style={{
  //                 marginRight: -4,
  //               }}
  //               id="customSwitch1"
  //             />
  //             <label
  //               style={{ whiteSpace: "nowrap" }}
  //               className="custom-control-label"
  //               htmlFor="customSwitch1"
  //             >
  //               Concise View
  //             </label>
  //           </div>{" "}<label
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //               fontSize: 14,
  //               cursor: "pointer",
  //             }}
  //           >
  //             <input
  //               className="custom-control-input"
  //               type="checkbox"
  //               checked={showConciseView}
  //               onChange={() => setShowConciseView((current) => !current)}
  //               style={{ marginRight: 4 }}
  //             />
  //             Concise View
  //           </label>
  //         </span>
  //       ) : null}*/}
  //     </nav>
  //   );
  // }
  return (
    <div style={{ width: "100%" }}>
      <nav
        style={{
          width: "100%",
          backgroundImage:
            "linear-gradient(45deg, rgb(224, 255, 232) 0%, rgb(233, 255, 235) 100%)",
        }}
        className="navbar navbar-expand-lg main-navigation"
      >
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {savedIcon === "Saving..." ? (
            <div className="navbar-brand-center">
              <h1
                style={{
                  fontSize: 30,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <svg
                  className="nav-icon"
                  style={{ width: "32px", height: "32px" }}
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    fill="#3b82f6"
                    stroke="#1e40af"
                    strokeWidth="2"
                  />
                  <circle cx="9.5" cy="9.5" r="1.5" fill="white" />
                  <circle cx="14.5" cy="9.5" r="1.5" fill="white" />
                  <circle cx="9.5" cy="14.5" r="1.5" fill="white" />
                  <circle cx="14.5" cy="14.5" r="1.5" fill="white" />
                </svg>
                CircleGri
                <div
                  style={{ fontSize: 15 }}
                  className="spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="sr-only"></span>
                </div>
                d
              </h1>
            </div>
          ) : (
            <Link className="navbar-brand-center" to="/">
              <h1
                style={{
                  fontSize: 30,
                  color: "black",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <svg
                  className="nav-icon"
                  style={{ width: "32px", height: "32px" }}
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    fill="#3b82f6"
                    stroke="#1e40af"
                    strokeWidth="2"
                  />
                  <circle cx="9.5" cy="9.5" r="1.5" fill="white" />
                  <circle cx="14.5" cy="9.5" r="1.5" fill="white" />
                  <circle cx="9.5" cy="14.5" r="1.5" fill="white" />
                  <circle cx="14.5" cy="14.5" r="1.5" fill="white" />
                </svg>
                CircleGrid
              </h1>
            </Link>
          )}
          <div className="collapse navbar-collapse main-navigation__content" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto main-navigation__links">
              <li className="nav-item">
                <Link
                  style={{ color: navColor1 }}
                  className="nav-link"
                  to="/Directory"
                >
                  <svg
                    className="nav-icon"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                  Directory
                </Link>
              </li>
              {uid ? (
                <>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor2 }}
                      className="nav-link"
                      to="/AddBusinesses"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                      </svg>
                      Add Business
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor3 }}
                      className="nav-link"
                      to="/Businesses"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
                      </svg>
                      Businesses Added
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/store-orders">
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2a3 3 0 006 0h6a3 3 0 006 0h2V12l-3-4zm-14 10.5A1.5 1.5 0 116 15a1.5 1.5 0 010 3.5zM15 15H8.82A3 3 0 003 15V6h12v9zm3 3.5a1.5 1.5 0 110-3.5 1.5 1.5 0 010 3.5zM17 12V10h2l1.5 2H17z" />
                      </svg>
                      Manage Orders
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor5 }}
                      className="nav-link"
                      to="/Deals"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
                      </svg>
                      Deals
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor6 }}
                      className="nav-link"
                      to="/Admin/Deals"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
                      </svg>
                      Admin
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor7 }}
                      className="nav-link"
                      to="/UserProfile"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                      </svg>
                      User Profile
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor8 }}
                      className="nav-link"
                      to="/Payment"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
                      </svg>
                      Payments
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor9 }}
                      className="nav-link"
                      to="/Analytics"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.25l1.41-1.41L15.5 12.5 13 15l-3.5-3.5-4.5 4.5 1.41 1.41L10 13.91l3.5 3.5 3.5-3.5z" />
                      </svg>
                      Analytics
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor10 }}
                      className="nav-link"
                      to="/Messages"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
                      </svg>
                      Messages
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{ color: navColor9 }}
                      className="nav-link"
                      to="/service-requests"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
                      </svg>
                      Service Requests
                    </Link>
                  </li>
                  <li className="nav-item customer-chat-nav-item">
                    <Link
                      className="nav-link"
                      to="/CustomerChat"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h11c.55 0 1-.45 1-1z" />
                      </svg>
                      Chat
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/guides">
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
                      </svg>
                      Guides
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/buyers-portal">
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                      </svg>
                      Find Services
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{
                        color: stylingOnClickPricing,
                        fontWeight: "bold",
                      }}
                      className="nav-link"
                      to="/Pricing"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" />
                      </svg>
                      Pricing
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      style={{
                        color: stylingOnClickFeatures,
                        fontWeight: "bold",
                      }}
                      className="nav-link"
                      to="/About"
                    >
                      <svg
                        className="nav-icon"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      </svg>
                      About
                    </Link>
                  </li>
                </>
              )}
            </ul>
            <div className="user-section">
              {savedIcon === "Saving..." ? (
                <div className="save-indicator">
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="sr-only"></span>
                  </div>
                  <span>Saving...</span>
                </div>
              ) : (
                <div className="save-indicator">
                  <svg
                    className="nav-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                  >
                    <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7l-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z" />
                    <path d="M5.354 7.146l.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z" />
                  </svg>
                  <span>Saved</span>
                </div>
              )}
              {uid ? (
                <Logout />
              ) : (
                <Link
                  to="/Login"
                  className="btn btn-link"
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  Login
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navigation;
